<template>
<m-pageframe
    title="Calendly Events"
>
<v-container
    fluid
>
    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickCreateCalendarEvent()"
                >
                    <v-list-item-title>Create...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> 
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_start_date="{ item }">
            {{$rc.pretty(item.time_start,'date')}}
        </template>

        <template v-slot:item.time_start_time="{ item }">
            {{$rc.pretty(item.time_start,'time')}}
        </template>

        <template v-slot:item.time_end_time="{ item }">
            {{$rc.pretty(item.time_end,'time')}}
        </template>

        
        <template v-slot:item.invitees="{ item }">
            <div
                v-for="(invitee, index) in item.invitees"
                :key="item.event_id+'_invitees_'+index"
            >
                {{invitee.name}} &mdash; {{invitee.email}}
            </div>
        </template>

        <template v-slot:item.action="{ item }">

            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
                    
            </template>
            
            <v-list>
                 <v-list-item
                    v-on:click="onClickEdit(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSetForOrganization(item)"
                >
                    <v-list-item-title>Set for organization...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickSelectPurpose(item)"
                >
                    <v-list-item-title>Set purpose...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 

        </template>
        
    </v-data-table>

    <m-edit-calendar-event-dialog
        ref="edit-calendar-event"
        v-on:update="doUpdate"
    />

    <m-autocomplete-organization
        :value="null"
        dialog_only
        ref="search-orgs"
        v-on:input="doSetOrganization"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            headers: [
                { text: 'System', value: 'content_type'},
                { text: 'Date', value: 'time_start_date'},
                { text: 'Start', value: 'time_start_time'},
                { text: 'End', value: 'time_end_time'},
                { text: 'Owner', value: 'owned_by_employee_label' },
                { text: 'Title', value: 'title' },
                { text: 'Invitees', value: 'invitees' },

                { text: 'For Organization', value: 'for_organization_label' },
                { text: 'Purpose', value: 'purpose' },
                { text: 'Action', value: 'action' }
            ],

            results: [],
            last_item: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/calendar/events',
            
                'params' : {
                        'full_text': this.full_text,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list events',
            });
        },

        onClickSelectPurpose(item)
        {
            this.$rc.pick({
                'title': 'Select purpose',
                'content_before': null,
                'content_after': null,
            
                'choices': this.$rc.enumChoices('event_purpose',true),
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Choose One',
                'initial_value': null,
            
                'on_ok': (value) => {

                    item.purpose = value;

                    this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PATCH: /api/v1/calendar/events',
                    
                        'params' : {
                            'content_type': item.content_type,
                            'event_id': item.event_id,
                            'purpose': value,
                            'for_organization_id': item.for_organization_id,
                        },
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to modify event',
                    });
                },
            
                'on_cancel': () => {}
            });
        },

        onClickCreateCalendarEvent()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/calendar/manual-event-stub',
            
                'params' : {
                    },
            
                'on_success': (data) => {
                        this.$refs['edit-calendar-event'].showDialog(data);
                    },
            
                'on_error': 'Unable to create stub calendar event',
            });
        },

        onClickSetForOrganization(item)
        {
            this.last_item = _.cloneDeep(item);
            this.$refs['search-orgs'].showDialog();
        },

        doSetOrganization(org_id)
        {
            this.$rc.rest({
                        'spinner': false,
                        'endpoint': 'PATCH: /api/v1/calendar/events',
                    
                        'params' : {
                            'content_type': this.last_item.content_type,
                            'event_id': this.last_item.event_id,
                            'purpose': this.last_item.purpose,
                            'for_organization_id': org_id,
                        },
                    
                        'on_success': (data) => {
                                this.doUpdate();
                            },
                    
                        'on_error': 'Unable to modify event',
                    });
        },

        onClickEdit(item)
        {
            this.$refs['edit-calendar-event'].showDialog(item);
        },
    },

           
}
</script>

<style lang="scss" scoped>
</style>

<!--
	
	final private Optional<String> join_url;
	
	
	final private Optional<UUID> for_organization_id;
	final private String for_organization_label;
	final private Optional<CalendlyEventPurpose> purpose;

-->